import React from "react";
import {
  Box,
  Grid,
  Typography,
} from "@mui/material";
import { useSelector } from "react-redux";
import { LoginState } from "../../components/Login/Types/index";
import MeetingCard from "./MeetingCard/MeetingCard";
import { useState, useEffect } from "react";
import { useGetAllMeetings } from "./Hooks";
import Loading from "../../components/Loading/Loading";
import { ReactComponent as AddMeetingVector } from "./Statics/Svg/CreateMeeting.svg";
import Skeleton from "@mui/material/Skeleton";
import { useDispatch } from "react-redux";
import { baseUrl } from "../../env"
import { setLoadingR } from "./MeetingsSlice/MeetingsSlice";
import { UseGetWebCheckinMeetingDetailsByMeetingId } from "./Hooks";
import { useNavigate } from "react-router-dom";
import LyBackdrop from "../../components/Layouts/BackDrop/BackDrop";
import ModalLyt from "../../components/Layouts/ModalLyt/ModalLyt";
import AddMeeting from "./LComponents/Forms/AddMeeting/AddMeeting";
import { Link } from "react-router-dom";
import DyButton from "../../components/GlobalComponents/DyButton/DyButton";
import EditMeeting from "./LComponents/Forms/EditMeeting/EditMeeting";
import DYToastMessage from "../../components/GlobalComponents/DyToastMessage/DYToastMessage";
import { NewUseStore } from "../../Store/newUseStore";
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import {
  faIR,
  GridDeleteIcon,
  DataGrid
} from "@mui/x-data-grid";
import LoadingSpinner from "../../components/Progress/LoadingSpinner";
// تعریف نوع داده‌ها

type MeetingData = {
  id: number;
  title: string;
  repeatMethod: string; // نحوه تکرار جلسه
  date: string;         // تاریخ جلسه
  startTime: string;    // ساعت شروع جلسه
  endTime: string;      // ساعت پایان جلسه
  description: string;  // توضیحات
};

type RowType = {
  id: number; // فرض بر این است که هر داده یک شناسه منحصر به فرد دارد
  title: string; // عنوان
  repeatMethod: string; // نحوه تکرار جلسه
  date: string; // تاریخ
  startTime: string; // ساعت شروع
  endTime: string; // ساعت پایان
  description: string; // توضیحات
};
const Meeting: React.FC = function () {
  
  //NADERI
  const updateNewCompanyId = NewUseStore((state) => state.updateNewCompanyId);
  const [showDownloadLink, setShowDownlodLink] = useState<boolean>(false);
  const [meetId, setMeetId] = useState<any>("");
  const [showToastMessage, setShowToastMessage] = useState<boolean>(false);
  const [meetingAsyncState, setMeetingAsyncState] = useState<any | null>(null);
  const [createTenantModal, setCreateTenantModal] = useState<boolean>(false);
  const [showToastMessage2, setShowToastMessage2] = useState<boolean>(false);
  const [selectionModel, setSelectionModel] = useState<string[]>([]); // یا number[] بسته به نوع شناسه‌ها

  const profileTenantId = NewUseStore((state) => state.newTenantId);
  const [isGridView, setIsGridView] = useState(true); // حالت نمای شبکه‌ای
  const toggleView = () => {
    setIsGridView(!isGridView); // تغییر حالت نمای شبکه‌ای
  };
  const navigate = useNavigate();
  const getDetSuccess = (data: any) => {
    if (
      (data &&
        data.webTeamHaveParentCheckinMeetingDetailsQueryResultDtos &&
        data.webTeamHaveParentCheckinMeetingDetailsQueryResultDtos.length >
          0) ||
      (data.webTeamWithoutParentCheckinMeetingDetailsQueryResultDtos &&
        data.webTeamWithoutParentCheckinMeetingDetailsQueryResultDtos.length >
          0)
    ) {
      const id =
        data.webTeamHaveParentCheckinMeetingDetailsQueryResultDtos &&
        data.webTeamHaveParentCheckinMeetingDetailsQueryResultDtos.length > 0
          ? data.webTeamHaveParentCheckinMeetingDetailsQueryResultDtos[0].id
          : data.webTeamWithoutParentCheckinMeetingDetailsQueryResultDtos[0].id;
      updateNewCompanyId(id);
      navigate("/companyTeams");
    } else {
      setMeetingAsyncState({
        isSuccess: false,
        metaData: { message: "اطلاعاتی برای نمایش وجود ندارد" },
      });
      setShowToastMessage(true);
    }
  };
  const getDetFailed = () => {};
  const {
    data: MeetDetData,
    isLoading: meetLoading,
    refetch: getAgain,
  } = UseGetWebCheckinMeetingDetailsByMeetingId(
    getDetSuccess,
    getDetFailed,
    meetId
  );
  // const profileTenantId = sessionStorage.getItem("tenantId");
  //AMIR const profileTenantId = useSelector(
  //   (state: any) => state.meetings.profileTenantId
  // );
  const priodId = useSelector((state: any) => state.meetings.priodId);
  const userPhoneNumber: string = useSelector(
    (state: any) => state.loign.userPhoneNumber
  );

  const {
    isLoading: meetLoadin,
    data: meetdata,
    isFetched,
    refetch: getAgain1,
  } = useGetAllMeetings({
    tenantId: profileTenantId,
    priodId: priodId,
    userPhoneNumber: userPhoneNumber,
  });
  //NADERI const meetingsDataa = useSelector(
  //   (state: any) => state?.meetings?.meetingsList?.meetingsList
  // );
  // const periodList = useSelector((state: any) => state.meetings.periodList);
  //NADERI const meetingLoadState = useSelector(
  //   (state: any) => state?.meetings?.meetingsList
  // );
  const [existData, setExistData] = useState<any>(null);
  const [accessForReport, setAccessForReport] = useState<boolean>(false);
  const [meetingLenght, setMeetingLenght] = useState<Number>(0);
  const [reloadMeetingData, setReloadMeetingData] = useState<boolean>(false);
  const [bank,setBank]=useState<boolean>(false);
  const [showEditMeeting, setshowEditMeeting] = useState<boolean>(false);
  const [meetingId, setMeetingId] = useState<string | null>(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // برای بررسی سایز صفحه

  useEffect(() => {
    if (meetdata) {
      let { accessibleForReport, meetingsList } = meetdata;
      setAccessForReport(accessibleForReport);
      setExistData(meetingsList);
      setMeetingLenght(meetingsList.length);
    }
    // console.log(meetdata)
  }, [meetdata]);

  
  useEffect(() => {
    if (meetdata) {
      let{bank}=meetdata;
      setBank(bank)
    }
  },[meetdata]);

  //NADERI useEffect(() => {
  //   if (meetingLoadState !== null) {
  //     let { meetingsList } = meetingLoadState;
  //     setExistData(meetingsList);
  //     setMeetingLenght(meetingsList.length);
  //     //  console.log(meetingsList.length)
  //   }
  // }, [meetingLoadState]);

  useEffect(() => {
    console.log(meetingId);
  }, [meetingId]);

  const initialCreateMeeting = () => {
    setCreateTenantModal(!createTenantModal);
  };


  if (meetLoadin || existData===null || isFetched!==true) {
    return <Box display={'flex'} 
    alignItems={'center'} 
    justifyContent={'center'} 
    width={'100%'} 
    height={'500px'} 
    boxShadow={4} borderRadius={3}>
      <LoadingSpinner  />
     </Box>
  }
  const rows: RowType[] = existData.map((info: MeetingData) => ({
    id: info.id,
    title: info.title,
    repeatMethod: info.repeatMethod,
    date: info.date,
    startTime: info.startTime,
    endTime: info.endTime,
    description: info.description,
  }));
  
  const columns = [
    { field: 'row', headerName: 'ردیف', flex: 1 },
    { field: 'title', headerName: 'سطح', flex: 1 },
    { field: 'repeatMethod', headerName: 'نحوه تکرار جلسه', flex: 1 },
    { field: 'date', headerName: 'تاریخ جلسه', flex: 1 },
    { field: 'startTime', headerName: 'ساعت شروع جلسه', flex: 1 },
    { field: 'endTime', headerName: 'ساعت پایان جلسه', flex: 1 },
    { field: 'description', headerName: 'توضیحات', flex: 1 },
  ];
  return (
    <Grid container spacing={1} px={2}>
      <Grid item xs={12}>
        <Box display={"flex"} flexDirection={"row-reverse"}>
        <Box display={"flex"} flexDirection={"row-reverse"} py={1} px={2}>
            <DyButton
              caption={"ایجاد جلسه"}
              color={"#00l387C"}
              // onClick={loginHandler}
              disbled={false}
              variant={"contained"}
              bgColor={"#00387C"}
              onClick={initialCreateMeeting}
              // type={'submit'}
            />

          </Box>
        </Box>
      </Grid>

      {existData &&
        existData.map((data: any, i: number): any => {
          return (
            // <Grid item md={4} xs={12} key={i}>
            //   <MeetingCard
            //     setMeetId={setMeetId}
            //     info={data}
            //     prog={i}
            //     accessForReport={accessForReport}
            //     setShowDownlodLink={setShowDownlodLink}
            //     setPMeetingId={setMeetingId}
            //     setshowEditMeeting={setshowEditMeeting}
            //     showEditMeeting={showEditMeeting}
            //     setShowToastMessage={setShowToastMessage}
            //     setDeleteMeetState={setMeetingAsyncState}
            //   />
            // </Grid>
            <Grid item md={4} xs={12} key={i}>
  <Box
                    key={i}
                    sx={{
                      transition: "all 0.3s ease",
                      "&:hover": {
                        transform: "scale(1.05)",
                        backgroundColor: "withesmoke",
                        // boxShadow: "0px 8px 20px rgba(0, 0, 0, 0.3)",
                        // borderRadius: "12px",
                      },
                      padding: "10px", // Add padding to ensure content isn't cut off during hover
                    }}
                  >
    <MeetingCard
      setMeetId={setMeetId}
      info={data}
      prog={i}
      accessForReport={accessForReport}
      bank={bank}
      setShowDownlodLink={setShowDownlodLink}
      setPMeetingId={setMeetingId}
      setshowEditMeeting={setshowEditMeeting}
      showEditMeeting={showEditMeeting}
      setShowToastMessage={setShowToastMessage}
      setDeleteMeetState={setMeetingAsyncState}
    />
  </Box>
</Grid>

          );
        })}

     {
      existData?.length===0 && <Box sx={{ display: 'flex',alignItems:'center',justifyContent:'center',height:'100%',width:'100%' }}>
        <Grid item xs={12}>
         <div className="w-full flex justify-center">
          <Typography fontSize={20}>
            <AddMeetingVector
              style={{
                width: "300px",
                height: "100%",
                alignSelf: "center",
                textAlign: "center",
              }}
              />
                در این دوره جلسه ایی وجود ندارد
              </Typography>
              </div>
        </Grid>
      
      </Box>
    } 

      {createTenantModal && (
        <ModalLyt
          title={"ایجاد جلسه"}
          height={700}
          width={isMobile ? '350px' : '900px'}  // در موبایل 350px و در سایر اندازه‌ها 600px
          showModal={Boolean(createTenantModal)}
          setShowModal={setCreateTenantModal}
        >
          <AddMeeting
            meetingLenght={meetingLenght}
            hideModal={setCreateTenantModal}
            setMeetingAsyncState={setMeetingAsyncState}
            setShowToastMessage2={setShowToastMessage2}
            profileTenantId={profileTenantId}
            onSuccess={getAgain1}
            onClose={setCreateTenantModal}
          />
        </ModalLyt>
      )}

      {showDownloadLink && (
        <ModalLyt
          showModal={Boolean(showDownloadLink)}
          setShowModal={setShowDownlodLink}
        >
          <Box width={"100%"} alignItems={"center"}>
            <Link
              target="_blank"
              to={`${baseUrl}Download/ExportMeetingDetails?meetingId=${meetId}`}
            >
              دریافت فایل
            </Link>
          </Box>
        </ModalLyt>
      )}

      {showEditMeeting && (
        <ModalLyt 
          showModal={showEditMeeting} 
          setShowModal={setshowEditMeeting}           
          width={isMobile ? '350px' : '900px'}  // در موبایل 350px و در سایر اندازه‌ها 600px
        >
          <EditMeeting
            meetingId={meetingId}
            hideModal={setshowEditMeeting}
            setMeetingAsyncState={setMeetingAsyncState}
            setShowToastMessage={setShowToastMessage}
            profileTenantId={profileTenantId}
          />
        </ModalLyt>
      )}

      {showToastMessage && (
        <DYToastMessage
          isSuccess={meetingAsyncState?.isSuccess}
          message={meetingAsyncState?.metaData.message}
          setShow={setShowToastMessage}
          show={showToastMessage}
        />
      )}
      {showToastMessage2 && (
          <DYToastMessage
            isSuccess={true}
            message={'عملیات با موفقیت انجام شد'}
            setShow={setShowToastMessage2}
            show={showToastMessage2}
          />
        )}
    </Grid>
  );
};

export default Meeting;
